export default "__VITE_ASSET__f4acaa39__"